module.exports = __webpack_public_path__ + "static/img/3.2b09257.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/sp/3.png
// module id = yV3V
// module chunks = 0